import React, {useEffect, useState} from 'react'
import {useHistory, useLocation} from 'react-router';

import {loadStripe} from '@stripe/stripe-js';

import {
    Page,
    Container
} from "./SignUp_PaymentInfo.styles";

import SignUpHeader from "components/SignUpHeader";
import HeaderStatusBar from "components/HeaderStatusBar";
import Api, {config} from "../../../api";
import {Button} from "@material-ui/core";
import {exitReact} from "../../../utils";

// @ts-ignore
const TempStars = window.TempStars;
// @ts-ignore
const app = window.app as any;

interface ErrorProps {
    email?: string;
    password?: string;
    terms?: string;
    err?: string;
}

const getStripe = async (country: number) => {
    const pubKey = config.stripe[country ? 'US' : 'CA'].pubKey //country key
    return await loadStripe(pubKey);
}

export default function SignUp_PaymentInfo() {
    const history = useHistory();
    const { state } = useLocation<{ country: number, locationId: number }>();
    const { country, locationId }  = state;
    const [errorMessage, setErrorMessage] = useState<ErrorProps>({});
    const [stripe, setStripe] = useState<any>();
    const [message, setMessage] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [card, setCard] = useState<any>();

    useEffect(() => {
        getStripe(country).then(stripe => setStripe(stripe))
    }, []);

    useEffect(() => {
        if (stripe && !card) {
            const cardElement = stripe.elements().create('card')
            cardElement.mount('#card-element');
            setCard(cardElement)
        }
    }, [stripe]);

    const goHome = () => {
        history.push({
            pathname: 'loading'
        });
        exitReact('home')
    }

    const doneButtonHandler = async () => {
        try {
            app.showPreloader('Saving Payment Info');

            if (!stripe) {
                return;
            }
            setIsLoading(true);

            const intent = await Api.createSetupIntent(locationId);

            const { error }: any = await stripe?.confirmCardSetup(intent?.client_secret, {
                payment_method: {
                    card: card
                }
            });


            if (error) {
                setIsLoading(false);
                app.hidePreloader();
                if (error.type === "card_error" || error.type === "validation_error") {
                    setMessage(error.message);
                } else {
                    setMessage("An unexpected error occurred.");
                }
                return;
            }

            await Api.updatePaymentInfo(locationId); // locationId
            TempStars.Analytics.track('add payment info');
            await TempStars.User.refresh();

            setIsLoading(false);
            app.hidePreloader();

            return goHome()
        } catch (error: any) {
            app.hidePreloader();
            if (error.type === "card_error" || error.type === "validation_error") {
                setMessage(error.message);
            } else {
                setMessage("An unexpected error occurred.");
            }
            return;
        }
    }

    return (
        <Page>
            <Container data-page="role-select" className={'no-swipeback'}>
                <HeaderStatusBar />

                <div className={"paymentForm"}>
                    <SignUpHeader
                        title= {'Add payment info'}
                        description={'Add your payment information now to make finding talent quick and easy.'}
                        error={message || errorMessage?.err
                            || (errorMessage && (errorMessage?.email || errorMessage?.password || errorMessage?.terms) && 'Please fix the errors below')}
                    />

                    <div id="card-element" className={'cardElement'} ></div>

                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className="bigButtonInNewStyle"
                        onClick={doneButtonHandler}
                        disabled={isLoading || !stripe}
                    >
                        {isLoading ? <div className="spinner" id="spinner"></div> : "Submit"}
                        <img
                            className="arrowIconFwdWhite"
                            alt=""
                            src={"img/arrowForward.svg"}
                        />
                    </Button>

                    <Button
                        variant="outlined"
                        color="primary"
                        size="large"
                        onClick={goHome}
                        className="bigButtonInNewStyle"
                    >
                        Do this later
                    </Button>

                </div>

                <div className="footer footerLinks"></div>
            </Container>
        </Page>
    )
}
